import { ApiError, Result } from "../base";
import { useBaseStore } from "@/stores/base";
import { Ref } from "vue";

export async function promptInvalidPermissions<T, E>(
	promise: Promise<Result<T, E>>
): Promise<Result<T, E>> {
	const baseStore = useBaseStore();
	const result = await promise;
	if (result.isErr()) {
		if (result?.error?.status === 403) {
			baseStore.showInvalidPermissions = result.error;
		}
	}
	return result;
}

export function loadingWrapper<T, E>(
	promise: Promise<Result<T, ApiError>>,
	delayMiliseconds: number | null = null
) {
	const baseStore = useBaseStore();
	baseStore.loadingWrapper = true;
	promise
		.then((r) =>
			setTimeout(() => {
				baseStore.loadingWrapper = false;
			}, delayMiliseconds ?? baseStore.loadingDefaultDelay)
		)
		.catch(() =>
			setTimeout(() => {
				baseStore.loadingWrapper = false;
			}, delayMiliseconds ?? baseStore.loadingDefaultDelay)
		);
	return promise;
}

export async function loadingWrapperAll(
	promises: Promise<Result<any, ApiError>>[],
	delayMiliseconds: number | null = null
): Promise<Result<any, ApiError>[]> {
	const baseStore = useBaseStore();
	baseStore.loadingWrapper = true;

	let results: Result<any, ApiError>[];
	results = await Promise.all(promises);

	setTimeout(() => {
		baseStore.loadingWrapper = false;
	}, delayMiliseconds ?? baseStore.loadingDefaultDelay);

	return results;
}

export function loadingWrapperLocal<T, E>(
	promise: Promise<Result<T, ApiError>>,
	loading: Ref<boolean>,
	delayMiliseconds: number | null = null
) {
	const baseStore = useBaseStore();
	loading.value = true;
	promise
		.then(() =>
			setTimeout(() => {
				loading.value = false;
			}, delayMiliseconds ?? baseStore.loadingDefaultDelay)
		)
		.catch(() =>
			setTimeout(() => {
				loading.value = false;
			}, delayMiliseconds ?? baseStore.loadingDefaultDelay)
		);
	return promise;
}
